import InteractiveEditor from "./interactiveEditor.container";

export default InteractiveEditor;
